import { render, staticRenderFns } from "./CommonSwitch.vue?vue&type=template&id=aa902d22&scoped=true"
import script from "./CommonSwitch.vue?vue&type=script&lang=js"
export * from "./CommonSwitch.vue?vue&type=script&lang=js"
import style0 from "./CommonSwitch.vue?vue&type=style&index=0&id=aa902d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa902d22",
  null
  
)

export default component.exports